import { useEffect } from "react";

const StructuredData = () => {
  useEffect(() => {
    // ====================================================
    // 1. LocalBusiness Schema with AggregateRating
    // ====================================================
    const localBusinessSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "@id": "https://www.reklam-uzmani.com.tr/#localbusiness",
      name: "Google Reklam Ajansı Dijital Mustafa",
      alternateName: ["Dijital Mustafa", "Dijital Mustafa - Google Ads Uzmanı", "Dijital Mustafa Google Ads Danışmanlığı"],
      image: "https://www.reklam-uzmani.com.tr/images/reklam-uzmani-logo.png",
      description: "Google Reklam Ajansı Dijital Mustafa — Google Ads Uzmanı olarak 18 yıllık Google Ads danışmanlığı deneyimimle Google Ads reklam uzmanı hizmeti sunuyorum. Google Partner sertifikalı profesyonel kampanya yönetimi.",
      url: "https://www.reklam-uzmani.com.tr",
      telephone: "+90 535 838 62 97",
      priceRange: "₺₺₺",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Adnan Kahveci, Yavuz Sultan Selim Blv. uyum çarşı içi kat 1 iç kapı no 72",
        addressLocality: "Beylikdüzü",
        addressRegion: "İstanbul",
        postalCode: "34528",
        addressCountry: "TR",
      },
      geo: {
        "@type": "GeoCoordinates",
        latitude: 39.9334,
        longitude: 32.8597,
      },
      openingHoursSpecification: {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        opens: "00:00",
        closes: "23:59",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.9",
        bestRating: "5",
        worstRating: "1",
        reviewCount: "127",
      },
      areaServed: [
        {
          "@type": "City",
          name: "İstanbul",
        },
        {
          "@type": "City",
          name: "Ankara",
        },
        {
          "@type": "City",
          name: "İzmir",
        },
        {
          "@type": "City",
          name: "Antalya",
        },
        {
          "@type": "City",
          name: "Bursa",
        },
        {
          "@type": "Country",
          name: "Türkiye",
        },
      ],
      sameAs: [
        "https://www.instagram.com/reklamuzmani",
        "https://www.facebook.com/reklamuzmani",
        "https://www.linkedin.com/company/reklamuzmani",
      ],
    };

    // ====================================================
    // 2. Organization Schema
    // ====================================================
    const organizationSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "@id": "https://www.reklam-uzmani.com.tr/#organization",
      name: "Dijital Mustafa",
      alternateName: ["Google Reklam Ajansı Dijital Mustafa", "Dijital Mustafa Google Ads Uzmanı"],
      url: "https://www.reklam-uzmani.com.tr",
      logo: "https://www.reklam-uzmani.com.tr/images/reklam-uzmani-logo.png",
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+90 535 838 62 97",
        contactType: "Customer Service",
        areaServed: "TR",
        availableLanguage: "Turkish",
      },
    };

    // ====================================================
    // 3. Service Schema - Hizmetleri Tanımlama
    // ====================================================
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "@id": "https://www.reklam-uzmani.com.tr/#service",
      serviceType: "Google Reklam Ajansı - Google Ads Reklam Verme Hizmetleri",
      provider: {
        "@id": "https://www.reklam-uzmani.com.tr/#localbusiness",
      },
      areaServed: {
        "@type": "Country",
        name: "Türkiye",
      },
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Google Reklam Ajansı Hizmetleri",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Google Ads Reklam Verme",
              alternateName: [
                "Google Reklam Ajansı",
                "Google Ads Uzmanı",
                "Google Reklam Uzmanı",
                "Google Ads Ajans",
                "Google Partner Ajansları",
                "Google Partner Ajans",
                "Google AdWords Uzmanı",
                "Google Ads Sahte Tıklama Engelleme",
                "Google Haritalarda Reklam Verme",
                "Google Ads Reklam Uzmanı",
                "Google Ajansı"
              ],
              description: "Google Reklam Ajansı olarak Google Partner Ajansları sertifikası ile profesyonel Google Ads reklam verme hizmeti",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Meta Reklamları Yönetimi",
              alternateName: [
                "Facebook Ads Yönetimi",
                "Instagram Ads Yönetimi",
                "Meta Ads Uzmanı",
                "Sosyal Medya Reklamları"
              ],
              description: "Facebook ve Instagram reklamlarınızı profesyonelce yönetin",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Dönüşüm Optimizasyonu",
              alternateName: [
                "CRO Hizmeti",
                "Conversion Rate Optimization",
                "Landing Page Optimizasyonu",
                "A/B Test Yönetimi"
              ],
              description: "Reklam bütçenizden maksimum dönüşüm alın",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Remarketing Kampanyaları",
              alternateName: [
                "Yeniden Pazarlama",
                "Retargeting Kampanyaları",
                "Google Remarketing",
                "Meta Retargeting"
              ],
              description: "Potansiyel müşterilerinize yeniden ulaşın ve satışlarınızı artırın",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "SEO Destekli Reklam Stratejisi",
              description: "Organik ve ücretli arama sonuçlarını birleştirerek maksimum görünürlük sağlayın",
            },
          },
        ],
      },
      offers: {
        "@type": "AggregateOffer",
        priceCurrency: "TRY",
        lowPrice: "20000",
        highPrice: "60000",
        availability: "https://schema.org/InStock",
        description: "Tüm paketlerde ücretsiz profesyonel web sitesi tasarımı hediyesi. 3 farklı yönetim paketi seçeneği.",
      },
    };

    // ====================================================
    // 4. BreadcrumbList Schema - Google Sitelinks İçin
    // ====================================================
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Ana Sayfa",
          item: "https://www.reklam-uzmani.com.tr/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Hizmetler",
          item: "https://www.reklam-uzmani.com.tr/#hizmetler",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Paketler",
          item: "https://www.reklam-uzmani.com.tr/#paketler",
        },
        {
          "@type": "ListItem",
          position: 4,
          name: "Sık Sorulan Sorular",
          item: "https://www.reklam-uzmani.com.tr/#sss",
        },
        {
          "@type": "ListItem",
          position: 5,
          name: "İletişim",
          item: "https://www.reklam-uzmani.com.tr/#iletisim",
        },
      ],
    };

    // ====================================================
    // 5. WebSite Schema - Sitelinks Search Box
    // ====================================================
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": "https://www.reklam-uzmani.com.tr/#website",
      url: "https://www.reklam-uzmani.com.tr",
      name: "Google Reklam Ajansı | Dijital Mustafa - Google Ads Uzmanı & Danışmanlığı",
      description: "Google Reklam Ajansı Dijital Mustafa — Google Ads Uzmanı olarak 18 yıllık Google Ads danışmanlığı deneyimimle Google Ads reklam uzmanı hizmeti sunuyorum.",
      potentialAction: {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: "https://www.reklam-uzmani.com.tr?s={search_term_string}",
        },
        "query-input": "required name=search_term_string",
      },
    };

    // ====================================================
    // 6. Person Schema - Dijital Mustafa
    // ====================================================
    const personSchema = {
      "@context": "https://schema.org",
      "@type": "Person",
      "@id": "https://www.reklam-uzmani.com.tr/#person",
      name: "Dijital Mustafa",
      jobTitle: "Google Ads Uzmanı",
      description: "Google Reklam Ajansı Dijital Mustafa — Google Ads Uzmanı olarak 18 yıllık Google Ads danışmanlığı deneyimimle Google Ads reklam uzmanı hizmeti sunuyorum. Google Partner sertifikalı, her projeyi bizzat ben yönetiyorum; bu yüzden ayda sadece 5 yeni firma kabul ediyorum.",
      image: "https://www.reklam-uzmani.com.tr/images/mustafa-kaya-profil.png",
      url: "https://www.reklam-uzmani.com.tr",
      telephone: "+90 535 838 62 97",
      knowsAbout: [
        "Google Reklam Ajansı",
        "Google Ads Reklam Verme",
        "Google Ads Uzmanı",
        "Google Reklam Uzmanı",
        "Google Ads Ajans",
        "Google Partner Ajansları",
        "Google Haritalarda Reklam Verme",
        "Google Partner Ajans",
        "Google AdWords Uzmanı",
        "Google Ads Sahte Tıklama Engelleme",
        "Google Ads Reklam Uzmanı",
        "Google Ajansı"
      ],
      hasOccupation: {
        "@type": "Occupation",
        name: "Google Ads Uzmanı",
        occupationLocation: {
          "@type": "Country",
          name: "Türkiye"
        },
        experienceRequirements: "18 yıl deneyim",
        skills: "Google Ads, Google Arama Ağı, Google Haritalar, YouTube Ads, Display Network, Sahte Tıklama Koruması"
      }
    };

    // ====================================================
    // Insert All Schemas into Head
    // ====================================================
    const schemas = [
      localBusinessSchema,
      organizationSchema,
      serviceSchema,
      breadcrumbSchema,
      websiteSchema,
      personSchema,
    ];

    schemas.forEach((schema, index) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = `structured-data-${index}`;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    // Cleanup function
    return () => {
      schemas.forEach((_, index) => {
        const script = document.getElementById(`structured-data-${index}`);
        if (script) {
          document.head.removeChild(script);
        }
      });
    };
  }, []);

  return null;
};

export default StructuredData;
